import React, { Component } from "react";

class TimerEnterprise extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			sessionTime: '00 : 00',
			timeSpent: '00:00',
			timeBefore: '00:00', 
			isEndedSession: false,
			redTimer: false,
		}
		
		this.xInterval = null;
	}
 
	componentDidMount(){
		
		var mainData = JSON.parse(localStorage.getItem('userData'));
		let currDate = new Date(mainData.sessionData.scheduleDate);
		currDate.setMinutes(currDate.getMinutes() + mainData.sessionData.duration);
		this.countdownTimer(currDate);
	}
	
	componentWillUnmount(){
		clearInterval(this.xInterval);
	}
	
	countdownTimer=(sessionDate)=>{
		if ( !window['isTutorialStarted'] )
			{
				var deadline = 0;
				var sessionData = JSON.parse(localStorage.getItem('userData')).sessionData;
				var fullTimeMinutes = sessionData.duration;
				var sessionStations = sessionData.sessionStations;
				var sessionTimes = [];
				for ( let i = 0; i < sessionStations.length; i++ ) { sessionTimes.push(sessionStations[i].time); }
				
				let tutorialData = JSON.parse(localStorage.getItem('tutorialData'));
				if ( tutorialData ) 
					{
						if ( this.state.currentUserData.sessionData.id == tutorialData.sessionId )
							{
								let currentUserData = JSON.parse(localStorage.getItem('userData'));
								let seconds = currentUserData['default']['defaultSessionDuration'] * 60;
								let currDate = new Date();
								currDate.setSeconds(currDate.getSeconds() + seconds);
								deadline = new Date(currDate).getTime();
							}
						else 
							{
								deadline = new Date(sessionDate).getTime();
							}							
					}
				else 
					{
						deadline = new Date(sessionDate).getTime();
					}
					
				var now,
				timeRemaining,
				hours,
				minutes,
				seconds;
				  
				var mainthis = this;
				this.xInterval = setInterval(function() {
					now = new Date().getTime(); 
					timeRemaining = deadline - now;
					
					let sessionStartTime = new Date(sessionData.scheduleDate).getTime();
					
					if ( mainthis.props.mainthis.state.sessionStartedByHost === false )
						{
							let timeToStart = sessionStartTime - now;
							timeToStart = timeToStart / 1000;
							if ( timeToStart > 0 && timeToStart < 11  )
								{
									mainthis.setState({tenSecRule: true});
								}								
						}
					else 
						{
							mainthis.setState({tenSecRule: false});
						}						
				
					if (timeRemaining < 0) 
						{ 
							clearInterval(mainthis.xInterval);
							mainthis.setState({
								sessionTime: 'Class Ended', 
								isEndedSession: true,
								redTimer: false,
								});
						} 
					else 
						{
							let allMinutes = Math.floor(timeRemaining / 60000);
							seconds = ("0" + (Math.floor((timeRemaining / 1000) % 60) % 60)).slice(-2);
							minutes = ("0" + Math.floor((timeRemaining / 60000) % 60)).slice(-2);
							hours = Math.floor((timeRemaining / 3600000));
							
							if(hours >= 100) {
							  hours = ("0" + hours).slice(-3);
							} else {
							  hours = ("0" + hours).slice(-2);
							}
							
							if ( mainthis.props.mainthis.state.multi_window == undefined || mainthis.props.mainthis.state.multi_window === false )
								{
									let time = hours + ':' + minutes + ':' + seconds;
									mainthis.setState({sessionTime: time});
								}
							else 
								{
									if ( parseInt(allMinutes) < 10 )
										{
											allMinutes = "0" + allMinutes;
										}
									let time = allMinutes + ':' + seconds;
									mainthis.setState({sessionTime: time});
									window['currentTimeClass'] = time;
									if ( parseInt(allMinutes) < 1 && parseInt(seconds) < 11 )
										{
											mainthis.setState({
												redTimer: true,	
											});
										}
								}								
							
							
							/* var totalMinutesLeft = (parseInt(hours) * 60) + parseInt(minutes);
							var currentMinute = fullTimeMinutes - totalMinutesLeft;
							
							if ( sessionTimes.indexOf(currentMinute) > -1 )
								{
									var index = sessionTimes.indexOf(currentMinute);
									var stationMain = sessionStations[index];
									if ( parseInt(stationMain.stationId) > 0 )
										{
											if ( mainthis.props.mainthis.state.currentStationId == stationMain.stationId ) { return false; }
											
											mainthis.props.mainthis.playPlayer(stationMain.stationId);
										}
									else
										{
											if ( mainthis.props.mainthis.state.currentStationId == "" ) { return false; }
											
											mainthis.props.mainthis.stopPlayer();
										}
								} */
				
						}
				}, 1000); 
			}
		
	}
	
	
	render() {
		return (
				<div className={"session_time " + ( this.state.isEndedSession ? "ended_session " : "" ) + ( this.state.redTimer ? "redTimer " : "" ) + ( this.state.tenSecRule ? "tenSecRule " : "" ) } id="session_time">{this.state.sessionTime}
					<div className="abs_border"></div>
				</div>
	)}
}
export default TimerEnterprise;
